// extracted by mini-css-extract-plugin
export default {"videoCTA":"video-list-cta__videoCTA--11SoS","videoCta":"video-list-cta__videoCTA--11SoS"};
    if(module.hot) {
      // 1776844075504
      var cssReload = require("/bento3/bento_cms/static_src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  